import type { PublicationInboxSummary } from '@/hooks/usePublicationInbox';
import type { PublicationInboxFolder } from '@/lib/publicationInboxPresentation';

type Props = {
  summary: PublicationInboxSummary;
  onSelectFolder: (
    folder: PublicationInboxFolder
  ) => void;
};

const cards: Array<{
  key: keyof PublicationInboxSummary;
  label: string;
  folder: PublicationInboxFolder;
  icon: string;
}> = [
  {
    key: 'deadlines',
    label: 'Possíveis prazos',
    folder: 'deadlines',
    icon: 'ri-timer-flash-line',
  },
  {
    key: 'action',
    label: 'Exigem providência',
    folder: 'action',
    icon: 'ri-flashlight-line',
  },
  {
    key: 'review',
    label: 'Revisões pendentes',
    folder: 'review',
    icon: 'ri-brain-line',
  },
  {
    key: 'hearings',
    label: 'Audiências',
    folder: 'hearings',
    icon: 'ri-calendar-event-line',
  },
  {
    key: 'unlinked',
    label: 'Sem vínculo',
    folder: 'unlinked',
    icon: 'ri-link-unlink-m',
  },
  {
    key: 'exceptions',
    label: 'Exceções',
    folder: 'action',
    icon: 'ri-error-warning-line',
  },
];

export default function PublicationAttentionSummary({
  summary,
  onSelectFolder,
}: Props) {
  return (
    <section className="rounded-2xl border border-background-200 bg-background-50 p-4">
      <div className="mb-3 flex flex-wrap items-end justify-between gap-2">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-foreground-400">
            Hoje exige sua atenção
          </p>
          <p className="mt-1 text-sm text-foreground-600">
            Priorize risco jurídico e providências pendentes.
          </p>
        </div>

        <div className="rounded-full border border-background-200 bg-white px-3 py-1 text-xs font-medium text-foreground-600">
          {summary.active} ativa{summary.active === 1 ? '' : 's'}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 md:grid-cols-3 xl:grid-cols-6">
        {cards.map((card) => (
          <button
            key={card.key}
            type="button"
            onClick={() =>
              onSelectFolder(card.folder)
            }
            className="rounded-xl border border-background-200 bg-white p-3 text-left transition hover:border-primary-200 hover:bg-primary-50/40"
          >
            <div className="flex items-center justify-between gap-2">
              <i className={`${card.icon} text-base text-foreground-500`}></i>
              <span className="text-xl font-bold text-foreground-900">
                {summary[card.key]}
              </span>
            </div>
            <p className="mt-2 text-xs font-medium text-foreground-600">
              {card.label}
            </p>
          </button>
        ))}
      </div>
    </section>
  );
}